module.exports = __webpack_public_path__ + "img/ctrl-r-theta-stub-down-+.9df89d25.svg";